//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "description"
}



// WEBPACK FOOTER //
// ./src/components/description/description.vue